import { createResource } from "@/core";
import type { IWebFile, IWebFileCreate, IWebFileUpdate } from "../types";

export const webFileResource = createResource<
  IWebFile,
  IWebFileCreate,
  IWebFileUpdate
>({
  endpoint: "/web-files",
  queryKey: "webFiles",
  staleTime: 10 * 60 * 1000,
});
